import { createSlice } from "@reduxjs/toolkit";
import {
  getAiAccessKey,
  generateAiAccessKey,
  revokeAiAccessKey,
  revealAiAccessKey,
  getAiAccessMcpConfig,
} from "./aiAccessActions";

const initialState = {
  loading: false,
  actionLoading: false,
  keyInfo: null,
  revealedKey: null,
  mcpConfig: null,
  error: null,
};

const aiAccessSlice = createSlice({
  name: "ai_access",
  initialState,
  reducers: {
    clearRevealedAiAccessKey: (state) => {
      state.revealedKey = null;
    },
    resetAiAccessError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAiAccessKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAiAccessKey.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.keyInfo = payload ? payload : null;
      })
      .addCase(getAiAccessKey.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(generateAiAccessKey.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(generateAiAccessKey.fulfilled, (state, { payload }) => {
        state.actionLoading = false;
        state.revealedKey = payload?.api_key ? payload?.api_key : null;
        state.mcpConfig = null;
      })
      .addCase(generateAiAccessKey.rejected, (state, { payload }) => {
        state.actionLoading = false;
        state.error = payload;
      })
      .addCase(revokeAiAccessKey.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(revokeAiAccessKey.fulfilled, (state) => {
        state.actionLoading = false;
        state.keyInfo = { exists: false };
        state.revealedKey = null;
        state.mcpConfig = null;
      })
      .addCase(revokeAiAccessKey.rejected, (state, { payload }) => {
        state.actionLoading = false;
        state.error = payload;
      })
      .addCase(revealAiAccessKey.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(revealAiAccessKey.fulfilled, (state, { payload }) => {
        state.actionLoading = false;
        state.revealedKey = payload?.api_key ? payload?.api_key : null;
      })
      .addCase(revealAiAccessKey.rejected, (state, { payload }) => {
        state.actionLoading = false;
        state.error = payload;
      })
      .addCase(getAiAccessMcpConfig.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(getAiAccessMcpConfig.fulfilled, (state, { payload }) => {
        state.actionLoading = false;
        // Guard against non-JSON 200s (e.g. an HTML page while the endpoint
        // is not deployed) — only a real config is worth caching.
        state.mcpConfig = payload?.connector_url ? payload : null;
      })
      .addCase(getAiAccessMcpConfig.rejected, (state, { payload }) => {
        state.actionLoading = false;
        state.error = payload;
      });
  },
});

export const { clearRevealedAiAccessKey, resetAiAccessError } =
  aiAccessSlice.actions;
export default aiAccessSlice.reducer;
